import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @flow

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import * as React from 'react';
import { CustomizeColumnsModalWrapper, ToggleButtonWrapper } from './Datagrid/addons/CustomizeColumns';

var useCustomizeColumns = function useCustomizeColumns(hooks) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isModalOpen = _React$useState2[0],
      setIsModalOpen = _React$useState2[1];

  hooks.useInstance.push(function (instance) {
    var customizeColumnsProps = instance.customizeColumnsProps;

    var _ref = customizeColumnsProps || {},
        labels = _ref.labels;

    Object.assign(instance, {
      customizeColumnsProps: _objectSpread(_objectSpread({}, customizeColumnsProps), {}, {
        isModalOpen: isModalOpen,
        setIsModalOpen: setIsModalOpen
      }),
      CustomizeColumnsButton: function CustomizeColumnsButton(props) {
        return /*#__PURE__*/React.createElement(ToggleButtonWrapper, _extends({
          iconTooltipLabel: labels === null || labels === void 0 ? void 0 : labels.iconTooltipLabel,
          isModalOpen: isModalOpen,
          setIsModalOpen: setIsModalOpen
        }, props));
      },
      CustomizeColumnsModal: CustomizeColumnsModalWrapper
    });
  });
};

export default useCustomizeColumns;